module.exports = __webpack_public_path__ + "static/media/65.83c689f0.jpg";